/* =============================================================================
   Serenacoast — theme interactions (vanilla JS, no deps)
   Drawers and sheets, product options (colour + size), add to bag, the bag drawer,
   product gallery + zoom, Complete the look, recommendations, recently viewed.
   Product data comes from Liquid, so there is no card generator here.
   ============================================================================= */
(function () {
  'use strict';

  var CFG = window.SC || {};
  var slice = function (list) { return [].slice.call(list); };

  /* Match Shopify's own money format (derived from a server-rendered sample) */
  var M_TPL = CFG.money || '$1,234.56';
  function money(cents) {
    var v = cents / 100;
    if (M_TPL.indexOf('1,234.56') > -1) return M_TPL.replace('1,234.56', v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    if (M_TPL.indexOf('1.234,56') > -1) return M_TPL.replace('1.234,56', v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    if (M_TPL.indexOf('1,235') > -1) return M_TPL.replace('1,235', Math.round(v).toLocaleString('en-US'));
    return '$' + v.toFixed(2);
  }

  /* ---------------------------------------------------------------------------
     Drawers (menu, bag, filters). The bag is pre-rendered with the page, so opening
     it is a CSS transform: no request, no spinner.
  --------------------------------------------------------------------------- */
  var overlay = function () { return document.querySelector('[data-overlay]'); };
  var opener = null;        /* what opened the bag, so focus can go back to it */
  var savingsSeen = false;  /* the saving counts up from $0 the first time the bag opens */
  function closeAll() {
    var bag = document.querySelector('#cart-drawer.is-open');
    document.querySelectorAll('.nav-drawer.is-open, .cart-drawer.is-open, .filter-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    var o = overlay(); if (o) o.classList.remove('is-open');
    document.querySelectorAll('.popup').forEach(function (p) { p.classList.add('u-hidden'); });
    document.body.style.overflow = '';
    if (bag && opener && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  }
  function open(id) {
    var map = { nav: '#nav-drawer', cart: '#cart-drawer', filter: '#filter-drawer', popup: '#welcome-popup' };
    var el = document.querySelector(map[id]); if (!el) return;
    if (id === 'popup') { el.classList.remove('u-hidden'); return; }
    var already = el.classList.contains('is-open');
    el.classList.add('is-open');
    var o = overlay(); if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (id === 'cart' && !already) {
      if (!opener) opener = document.activeElement;
      setTimeout(function () { var c = el.querySelector('[data-close]'); if (c && el.classList.contains('is-open')) c.focus({ preventScroll: true }); }, 80);
      var sv = el.querySelector('[data-savings]');
      if (sv && !savingsSeen) { savingsSeen = true; countUp(sv.querySelector('[data-savings-amount]'), 0, +sv.getAttribute('data-cents')); }
    }
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) { e.preventDefault(); if (op.getAttribute('data-open') === 'cart') opener = op; open(op.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target.matches('[data-overlay]')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (!document.querySelector('dialog[open]')) closeAll(); return; }
    /* Tab stays inside the open bag */
    if (e.key !== 'Tab' || document.querySelector('dialog[open]')) return;
    var bag = document.querySelector('#cart-drawer.is-open'); if (!bag) return;
    var f = slice(bag.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), [tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (!bag.contains(cur)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------------------------------------------------------------------
     Sheets (native <dialog>): size guide and photo zoom. They sit in the top layer,
     above the sticky header and every drawer. A tap on the backdrop or a
     [data-sheet-close] button closes them.
  --------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var so = e.target.closest('[data-size-open]');
    if (so) { e.preventDefault(); var d = document.getElementById('size-guide-modal'); if (d && d.showModal && !d.open) d.showModal(); return; }
    var sc = e.target.closest('[data-sheet-close]');
    if (sc) { var dlg = sc.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.tagName === 'DIALOG' && (e.target.classList.contains('sheet') || e.target.classList.contains('lightbox'))) e.target.close();
  });

  /* Size chart: centimetres / inches */
  document.addEventListener('click', function (e) {
    var u = e.target.closest('[data-unit]'); if (!u) return;
    var chart = u.closest('[data-size-chart]'); if (!chart) return;
    var cm = u.getAttribute('data-unit') === 'cm';
    chart.querySelectorAll('[data-unit]').forEach(function (b) { var on = b === u; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    chart.querySelectorAll('[data-in]').forEach(function (s) { s.hidden = cm; });
    chart.querySelectorAll('[data-cm]').forEach(function (s) { s.hidden = !cm; });
  });

  /* Tabs (cosmetic) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.tab'); if (!tab) return;
    var group = tab.closest('.tabs'); if (!group) return;
    group.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
  });

  /* Exclusive accordions — only one <details> open per .accordion group */
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item.matches || !item.matches('.accordion__item') || !item.open) return;
    var group = item.closest('.accordion'); if (!group) return;
    group.querySelectorAll('.accordion__item[open]').forEach(function (d) { if (d !== item) d.open = false; });
  }, true);

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty__btn'); if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input'); if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v += (btn.textContent.trim() === '+' ? 1 : -1);
    input.value = Math.max(1, v);
    if (input.form) input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------------
     Product gallery — a swipe with a "1 / 8" counter on phones, a photo grid on
     desktop, and tap to zoom. Photos past the second load as they come near.
  --------------------------------------------------------------------------- */
  var galleryApi = null;
  function gallery() {
    var stage = document.querySelector('[data-gallery-stage]'); if (!stage) return;
    var slides = slice(stage.querySelectorAll('.pdp__slide'));
    var count = document.querySelector('[data-gallery-count]');
    function hydrate(slide) {
      var im = slide && slide.querySelector('img[data-srcset]'); if (!im) return;
      im.srcset = im.getAttribute('data-srcset'); im.src = im.getAttribute('data-src');
      im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
    }
    function setActive(i) {
      if (count) count.textContent = i + 1;
      hydrate(slides[i]); hydrate(slides[i + 1]);
    }
    var wide = window.matchMedia ? matchMedia('(min-width: 990px)') : { matches: false };
    function goTo(i) { var s = slides[i]; if (!s) return; hydrate(s); stage.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
    galleryApi = {
      /* Phones: swipe to that colour's photo. Desktop grid: bring it to the front of the grid. */
      goToMedia: function (id) {
        if (!id) return;
        for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(id)) {
          slides.forEach(function (s, n) { s.classList.toggle('is-lead', n === i && i > 0); });
          hydrate(slides[i]);
          if (wide.matches) { var r = stage.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 120, behavior: 'smooth' }); }
          else { goTo(i); setActive(i); }
          return;
        }
      }
    };
    if ('IntersectionObserver' in window) {
      /* The swipe loads a photo when it is one swipe away; the desktop grid, one screen away */
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { hydrate(en.target); io.unobserve(en.target); } });
      }, wide.matches ? { rootMargin: '700px 0px' } : { root: stage, rootMargin: '0px 100% 0px 100%' });
      slides.forEach(function (s) { if (s.querySelector('img[data-srcset]')) io.observe(s); });
      /* Videos play muted while on screen and pause when they leave */
      var vids = slice(stage.querySelectorAll('.pdp__slide--video video'));
      if (vids.length) {
        var vio = new IntersectionObserver(function (es) {
          es.forEach(function (en) { var v = en.target; if (en.intersectionRatio >= 0.6) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: [0, 0.6] });
        vids.forEach(function (v) { vio.observe(v); });
      }
    } else { slides.forEach(hydrate); }
    var more = document.querySelector('[data-gallery-more]');
    if (more) more.addEventListener('click', function () { stage.classList.add('is-all'); more.hidden = true; });
    if (slides.length > 1) {
      var raf;
      stage.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var center = stage.scrollLeft + stage.clientWidth / 2, best = 0, bestD = Infinity;
          slides.forEach(function (s, i) { var c = s.offsetLeft + s.clientWidth / 2; var d = Math.abs(c - center); if (d < bestD) { bestD = d; best = i; } });
          setActive(best);
        });
      }, { passive: true });
    }

    /* Tap a photo to open it full screen; tap again to zoom in and pan */
    var box = null;
    function openZoom(start) {
      if (!box) {
        box = document.createElement('dialog'); box.className = 'lightbox'; box.setAttribute('aria-label', 'Product photos');
        box.innerHTML = '<div class="lightbox__track"></div><span class="lightbox__count"></span>' +
          '<button type="button" class="lightbox__nav lightbox__nav--prev" data-zoom-step="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>' +
          '<button type="button" class="lightbox__nav lightbox__nav--next" data-zoom-step="1" aria-label="Next photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>' +
          '<button type="button" class="lightbox__close" data-sheet-close aria-label="Close photos"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
        var track = box.firstChild, counter = box.querySelector('.lightbox__count');
        slides.forEach(function (s) {
          var z = s.querySelector('[data-zoom]'), small = s.querySelector('img'); if (!z) return;
          var f = document.createElement('figure'); f.className = 'lightbox__slide';
          var im = new Image(); im.alt = small ? small.alt : ''; im.setAttribute('data-src', z.getAttribute('data-zoom-src'));
          f.appendChild(im); track.appendChild(f);
        });
        var figs = slice(track.children);
        var load = function (i) { [i - 1, i, i + 1].forEach(function (n) { var im = figs[n] && figs[n].querySelector('img[data-src]'); if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } }); };
        var at = 0;
        var show = function (i) { at = i; counter.textContent = (i + 1) + ' / ' + figs.length; load(i); };
        var step = function (d) { var n = Math.max(0, Math.min(figs.length - 1, at + d)); figs.forEach(function (x) { x.classList.remove('is-zoomed'); }); track.classList.remove('is-locked'); track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); show(n); };
        box.addEventListener('click', function (e) { var b = e.target.closest('[data-zoom-step]'); if (b) step(+b.getAttribute('data-zoom-step')); });
        box.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); step(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); } });
        if (figs.length < 2) slice(box.querySelectorAll('.lightbox__nav')).forEach(function (b) { b.hidden = true; });
        var zr;
        track.addEventListener('scroll', function () {
          if (zr) cancelAnimationFrame(zr);
          zr = requestAnimationFrame(function () { show(Math.round(track.scrollLeft / track.clientWidth)); });
        }, { passive: true });
        track.addEventListener('click', function (e) {
          var f = e.target.closest('.lightbox__slide'); if (!f) return;
          var on = !f.classList.contains('is-zoomed');
          figs.forEach(function (x) { x.classList.remove('is-zoomed'); x.scrollTop = 0; x.scrollLeft = 0; });
          f.classList.toggle('is-zoomed', on); track.classList.toggle('is-locked', on);
          if (on) { f.scrollLeft = (f.scrollWidth - f.clientWidth) / 2; f.scrollTop = (f.scrollHeight - f.clientHeight) / 3; }
        });
        box.addEventListener('close', function () { figs.forEach(function (x) { x.classList.remove('is-zoomed'); }); track.classList.remove('is-locked'); });
        box._go = function (i) { show(i); track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' }); };
        document.body.appendChild(box);
      }
      box.showModal(); box._go(start);
    }
    var downX = 0, downY = 0;
    stage.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; });
    stage.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom]'); if (!z || !window.HTMLDialogElement) return;
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return; /* a swipe, not a tap */
      openZoom(+z.getAttribute('data-zoom'));
    });
  }

  /* Photos that are not on the first screen (product cards further down a collection, cards
     waiting off to the side in a carousel) carry their address in data-srcset and are fetched
     when they come within about a screen of view. A carousel fetches all of its photos the
     first time it is touched, so nothing arrives late mid-swipe. */
  var lazyIO = null;
  function hydrateImg(im) {
    if (!im.hasAttribute('data-srcset')) return;
    im.srcset = im.getAttribute('data-srcset');
    if (im.hasAttribute('data-src')) im.src = im.getAttribute('data-src');
    im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
  }
  function lazyImages(scope) {
    var imgs = slice((scope || document).querySelectorAll('img[data-srcset]')).filter(function (im) { return !im.closest('[data-gallery-stage]'); });
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(hydrateImg); return; }
    if (!lazyIO) {
      var opts = { rootMargin: '500px 320px' };
      try { lazyIO = new IntersectionObserver(seen, { rootMargin: opts.rootMargin, scrollMargin: '0px 320px' }); } catch (e) { lazyIO = new IntersectionObserver(seen, opts); }
    }
    imgs.forEach(function (im) { if (!im.__lazy) { im.__lazy = true; lazyIO.observe(im); } });
    function seen(es) { es.forEach(function (en) { if (en.isIntersecting) { hydrateImg(en.target); lazyIO.unobserve(en.target); } }); }
  }
  function carouselImages(e) {
    var track = e.target.closest && e.target.closest('.carousel__track'); if (!track || track.__all) return;
    track.__all = true; slice(track.querySelectorAll('img[data-srcset]')).forEach(hydrateImg);
  }
  document.addEventListener('pointerdown', carouselImages, { passive: true });
  document.addEventListener('touchstart', carouselImages, { passive: true });
  document.addEventListener('scroll', carouselImages, { passive: true, capture: true });
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-carousel-prev], [data-carousel-next]'); if (b) { var c = b.closest('.carousel'); slice(c ? c.querySelectorAll('img[data-srcset]') : []).forEach(hydrateImg); } });

  /* Product cards: the second photo is only fetched on hover-capable devices (or on keyboard focus) */
  function loadHoverImage(e) {
    var card = e.target.closest && e.target.closest('.product-card'); if (!card) return;
    var im = card.querySelector('img[data-hover-src]'); if (!im) return;
    im.src = im.getAttribute('data-hover-src'); im.removeAttribute('data-hover-src');
  }
  document.addEventListener('mouseover', loadHoverImage);
  document.addEventListener('focusin', loadHoverImage);

  /* Carousel nav */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');
    if (!prev && !next) return;
    var wrap = (prev || next).closest('.carousel');
    var track = wrap && wrap.querySelector('.carousel__track'); if (!track) return;
    var first = track.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: (next ? 1 : -1) * step * 2, behavior: 'smooth' });
  });

  /* Reveal on scroll */
  function observeReveals() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Run fn once el is within `margin` of the viewport (or straight away without IntersectionObserver) */
  function whenNear(el, margin, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) { if (es.some(function (en) { return en.isIntersecting; })) { io.disconnect(); fn(); } }, { rootMargin: margin });
    io.observe(el);
  }

  function headerScroll() {
    var h = document.querySelector('[data-header]'); if (!h) return;
    var on = function () { h.classList.toggle('is-scrolled', window.scrollY > 4); };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  function stickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]'); if (!bar) return;
    var main = document.querySelector('.buybox [data-add]');
    if (!main || !('IntersectionObserver' in window)) { return; }
    var mainAbove = false, footerVisible = false;
    function apply() { bar.classList.toggle('is-visible', mainAbove && !footerVisible); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { mainAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
      apply();
    }, { threshold: 0 }).observe(main);
    var footer = document.querySelector('.footer');
    if (footer) new IntersectionObserver(function (es) {
      es.forEach(function (e) { footerVisible = e.isIntersecting; });
      apply();
    }, { threshold: 0 }).observe(footer);
  }

  /* ---------------------------------------------------------------------------
     Product options — colour swatches + size buttons (snippets/product-options.liquid).
     One controller per [data-po]; it works out the variant, crosses out what is sold
     out, and refuses to hand back a variant until every option has been chosen.
  --------------------------------------------------------------------------- */
  function initOptions(root) {
    if (!root) return null;
    if (root.__po) return root.__po;
    var dataEl = root.querySelector('[data-po-variants]'); if (!dataEl) return null;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var groups = slice(root.querySelectorAll('[data-po-group]'));
    var idEl = root.querySelector('[data-po-id]');
    var nOpts = variants.length ? variants[0].o.length : 0;
    var gi = function (g) { return +g.getAttribute('data-po-group'); };
    function chosen() {
      var o = []; for (var i = 0; i < nOpts; i++) o[i] = groups.length ? null : variants[0].o[i];
      groups.forEach(function (g) { var r = g.querySelector('input:checked'); o[gi(g)] = r ? r.value : null; });
      return o;
    }
    function fits(v, o, skip) { return v.o.every(function (x, i) { return i === skip || o[i] == null || o[i] === x; }); }
    function setError(g, on) { var er = g.querySelector('[data-po-error]'); if (er) er.hidden = !on; g.classList.toggle('has-error', on); }
    var api = { root: root, variants: variants, state: {} };

    function refresh(changed) {
      var o = chosen();
      /* A size that doesn't exist in the newly chosen colour is cleared, never silently swapped */
      if (changed != null) groups.forEach(function (g) {
        var i = gi(g); if (i === changed || o[i] == null) return;
        if (!variants.some(function (v) { return fits(v, o, -1); })) { var r = g.querySelector('input:checked'); if (r) r.checked = false; o[i] = null; }
      });
      groups.forEach(function (g) {
        var i = gi(g), isColor = g.getAttribute('data-po-name') === 'color', shown = '';
        slice(g.querySelectorAll('input')).forEach(function (inp) {
          var exists = false, avail = false;
          variants.forEach(function (v) {
            if (v.o[i] !== inp.value) return;
            /* A colour is judged on its own; a size is judged within the chosen colour */
            if (!isColor && !fits(v, o, i)) return;
            exists = true; if (v.a) avail = true;
          });
          var lab = inp.closest('label');
          lab.classList.toggle('is-unavailable', !avail);
          lab.classList.toggle('is-selected', inp.checked);
          inp.disabled = !exists;
          if (inp.checked) shown = inp.getAttribute('data-short') || inp.value;
        });
        var val = g.querySelector('[data-po-value]'); if (val) val.textContent = shown;
        if (o[i] != null) setError(g, false);
      });
      var complete = o.every(function (x) { return x != null; });
      var matches = variants.filter(function (v) { return fits(v, o, -1); });
      var exact = complete ? matches[0] : null;
      var preview = exact || matches.filter(function (v) { return v.a; })[0] || matches[0] || variants[0];
      if (idEl) idEl.value = exact ? exact.id : '';
      api.state = { options: o, complete: complete, variant: exact || null, preview: preview };
      var changedName = null;
      groups.forEach(function (g) { if (gi(g) === changed) changedName = g.getAttribute('data-po-name'); });
      root.dispatchEvent(new CustomEvent('po:change', { bubbles: true, detail: { changed: changedName, variant: exact || null, preview: preview, complete: complete } }));
    }

    /* Returns the chosen variant, or shows what is missing and returns null */
    api.validate = function () {
      var o = chosen(), bad = null;
      groups.forEach(function (g) { var miss = o[gi(g)] == null; setError(g, miss); if (miss && !bad) bad = g; });
      groups.forEach(function (g) { var fold = g.querySelector('.po__fold'); if (fold && o[gi(g)] == null) fold.open = true; });
      if (bad) {
        var r = bad.getBoundingClientRect();
        if (r.top < 100 || r.bottom > window.innerHeight - 100) bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        bad.classList.remove('is-nudged'); void bad.offsetWidth; bad.classList.add('is-nudged');
        var first = bad.querySelector('input:not([disabled])'); if (first) first.focus({ preventScroll: true });
        return null;
      }
      var v = api.state.variant;
      return v && v.a ? v : null;
    };

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[type=radio]')) return;
      var g = e.target.closest('[data-po-group]'); refresh(g ? gi(g) : null);
      var fold = g && g.querySelector('.po__fold'); if (fold) fold.open = false;
    });
    root.__po = api;
    refresh(null);
    return api;
  }

  /* A swatch is a square crop of the colour's photo; this gives the same photo uncropped at `width` */
  function uncropped(src, width) {
    try { var u = new URL(src, location.href); u.searchParams.delete('crop'); u.searchParams.delete('height'); u.searchParams.set('width', width); return u.toString(); }
    catch (e) { return src; }
  }
  function setPrices(scope, prefix, v) {
    if (!v) return;
    var sale = v.c > v.p * 1.01; /* a few cents above the price is a data slip, not a saving */
    /* text is only written when it has changed, so an unchanged price costs no layout */
    var now = money(v.p), was = sale ? money(v.c) : '';
    scope.querySelectorAll('[data-' + prefix + '-price]').forEach(function (el) { if (el.textContent !== now) el.textContent = now; el.classList.toggle('is-sale', sale); });
    scope.querySelectorAll('[data-' + prefix + '-compare]').forEach(function (el) { el.hidden = !sale; if (sale && el.textContent !== was) el.textContent = was; });
    scope.querySelectorAll('[data-' + prefix + '-save]').forEach(function (el) { el.hidden = !sale; if (sale) el.textContent = 'Save ' + Math.floor((v.c - v.p) * 100 / v.c) + '%'; });
  }
  /* The button never goes grey without saying why: it stays tappable until a real sold-out choice is made */
  function setAddState(btns, d) {
    var missing = d.complete && !d.variant, sold = d.complete && d.variant && !d.variant.a;
    btns.forEach(function (b) {
      if (b.hasAttribute('data-sold-out')) return;
      b.disabled = !!(missing || sold);
      var lbl = b.querySelector('.js-add-label'); if (lbl) lbl.textContent = sold ? 'Sold out' : missing ? 'Unavailable' : 'Add to bag';
    });
  }
  function lookTotal(look) {
    if (!look) return;
    var sum = 0, n = 0;
    look.querySelectorAll('[data-look-item]').forEach(function (it) {
      var inc = it.querySelector('[data-look-include]'), on = !inc || inc.checked;
      it.classList.toggle('is-off', !on);
      var po = initOptions(it.querySelector('[data-po]'));
      if (on && po && po.state.preview) { sum += po.state.preview.p; n++; }
    });
    var t = look.querySelector('[data-look-total]'); if (t) t.textContent = money(sum);
    var b = look.querySelector('[data-add]'); if (b) b.disabled = n === 0;
  }

  document.addEventListener('po:change', function (e) {
    var d = e.detail, root = e.target;
    var item = root.closest('[data-look-item]');
    if (item) {
      setPrices(item, 'po', d.preview); lookTotal(item.closest('[data-look]'));
      var chip = root.querySelector('.po-swatch.is-selected img'), lt = item.querySelector('[data-look-thumb]');
      if (d.changed === 'color' && chip && lt) lt.src = uncropped(chip.src, 240);
      return;
    }
    var qa = root.closest('[data-qa]');
    if (qa) { setPrices(qa, 'po', d.preview); setAddState(slice(qa.querySelectorAll('[data-add]')), d); return; }
    if (root.closest('#product-form')) pdpChange(d);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches) return;
    if (e.target.matches('[data-look-include]')) lookTotal(e.target.closest('[data-look]'));
    /* Once the shopper picks inside the "this piece" row, it stops following the main selection */
    var cur = e.isTrusted && e.target.closest('[data-look-current]'); if (cur) cur.__touched = true;
  });
  /* The "this piece" row of Complete the look follows the colour and size chosen at the top of the page */
  function syncLookCurrent(v) {
    var row = document.querySelector('[data-look-current]'); if (!row || row.__touched || !v) return;
    row.querySelectorAll('[data-po-group]').forEach(function (g) {
      var want = v.o[+g.getAttribute('data-po-group')];
      slice(g.querySelectorAll('input')).forEach(function (inp) {
        if (inp.value === want && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }

  /* Product page: price, sale saving, button, gallery and URL follow the selection */
  function pdpChange(d) {
    var v = d.preview;
    setPrices(document, 'pdp', v);
    setAddState(slice(document.querySelectorAll('#product-form [data-add], [data-add][form="product-form"]')), d);
    var err = document.querySelector('#product-form [data-add-error]'); if (err && d.changed != null) err.hidden = true;
    if (d.changed === 'color' && galleryApi) {
      galleryApi.goToMedia(v.m);
      var chip = document.querySelector('#product-form .po-swatch.is-selected img'), thumb = document.querySelector('[data-pdp-thumb]');
      if (chip && thumb) thumb.src = uncropped(chip.src, 120);
    }
    /* What the shopper is looking at has changed by now; the rest waits until that has been painted,
       so the tap itself stays quick */
    if (d.variant) afterPaint(function () {
      syncLookCurrent(d.variant);
      if (d.changed != null && window.history && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set('variant', d.variant.id); history.replaceState(history.state, '', u.toString()); } catch (err2) {}
      }
    });
  }
  function afterPaint(fn) { requestAnimationFrame(function () { setTimeout(fn, 0); }); }

  /* ---------------------------------------------------------------------------
     Bag — the side cart and the cart page. Adding, changing a quantity and removing
     are each one round trip: the response carries the freshly rendered bag
     (Section Rendering API), which is swapped in place.
  --------------------------------------------------------------------------- */
  function bagCount() { var d = document.querySelector('#cart-drawer'); return d ? parseInt(d.getAttribute('data-cart-count') || '0', 10) || 0 : 0; }
  function updateCartCount(n) {
    var btn = document.querySelector('.header__cart'); if (!btn) return;
    var badge = btn.querySelector('.header__count');
    if (n > 0) { if (!badge) { badge = document.createElement('span'); badge.className = 'header__count'; btn.appendChild(badge); } badge.textContent = n; }
    else if (badge) { badge.remove(); }
  }

  var reducedMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Count a money figure from one amount to another (the bag's saving) */
  function countUp(el, from, to) {
    if (!el) return;
    if (reducedMotion || from === to) { el.textContent = money(to); return; }
    var t0 = null;
    requestAnimationFrame(function step(now) {
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / 600), ease = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round(from + (to - from) * ease));
      if (k < 1) requestAnimationFrame(step);
    });
  }
  /* What the bag showed before a re-render, so the saving can move from there */
  function bagState(scope) {
    var sv = scope && scope.querySelector('[data-savings]');
    return { saving: sv ? +sv.getAttribute('data-cents') : 0 };
  }
  function animateBag(scope, prev, visible) {
    var sv = scope.querySelector('[data-savings]'); if (!sv || !visible) return;
    var now = +sv.getAttribute('data-cents');
    savingsSeen = true;
    countUp(sv.querySelector('[data-savings-amount]'), prev.saving, now);
    if (now > prev.saving && !reducedMotion) { sv.classList.remove('is-pulse'); void sv.offsetWidth; sv.classList.add('is-pulse'); }
  }
  /* Which control had focus, so it can have it again after the bag is re-rendered */
  function focusKey(scope) {
    var el = document.activeElement; if (!el || !scope.contains(el)) return null;
    if (el.hasAttribute('data-qty-dir')) return '[data-line="' + el.getAttribute('data-line') + '"][data-qty-dir="' + el.getAttribute('data-qty-dir') + '"]';
    if (el.hasAttribute('data-checkout')) return '[data-checkout]';
    return '[data-close]';
  }
  function parse(html, selector) { var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim(); return tmp.querySelector(selector); }

  /* Swap in freshly rendered bag markup: the side cart, and the cart page when it is on screen */
  function renderCart(sections) {
    if (!sections) return;
    var cur = document.querySelector('#cart-drawer'), fresh = parse(sections['cart-drawer'], '#cart-drawer');
    if (cur && fresh) {
      var isOpen = cur.classList.contains('is-open'), prev = bagState(cur), key = isOpen ? focusKey(cur) : null;
      var body = cur.querySelector('.sc__body'), top = body ? body.scrollTop : 0;
      if (isOpen) fresh.classList.add('is-open');
      cur.replaceWith(fresh);
      var nb = fresh.querySelector('.sc__body'); if (nb) nb.scrollTop = top;
      animateBag(fresh, prev, isOpen);
      if (key) { var again = fresh.querySelector(key) || fresh.querySelector('[data-close]'); if (again) again.focus({ preventScroll: true }); }
      updateCartCount(parseInt(fresh.getAttribute('data-cart-count') || '0', 10));
    }
    var page = document.querySelector('[data-main-cart]'), freshPage = parse(sections['main-cart'], '[data-main-cart]');
    if (page && freshPage) {
      var prevPage = bagState(page), pageKey = focusKey(page);
      page.innerHTML = freshPage.innerHTML;
      animateBag(page, prevPage, true);
      if (pageKey && pageKey !== '[data-close]') { var pa = page.querySelector(pageKey); if (pa) pa.focus({ preventScroll: true }); }
    }
  }
  function cartSections() { return document.querySelector('[data-main-cart]') ? ['cart-drawer', 'main-cart'] : ['cart-drawer']; }
  function refreshCart() {
    return fetch('/?sections=' + cartSections().join(','), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  /* Resolves with { ok, data }; a network failure rejects */
  function cartPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }, function () { return { ok: false, data: null }; }); });
  }

  /* Add to bag is one round trip: the button shows its loading state, the response carries the
     freshly rendered bag, and the bag opens with the item already in it (never empty or spinning). */
  var ADD_FAILED = 'Sorry, we couldn’t add that to your bag. Please try again.';
  function addToBag(items, form, extraBtn) {
    var btns = form ? slice(form.querySelectorAll('[data-add]')) : [];
    if (form && form.id) btns = btns.concat(slice(document.querySelectorAll('[data-add][form="' + form.id + '"]')));
    if (extraBtn) btns.push(extraBtn);
    if (btns.some(function (b) { return b.classList.contains('is-loading'); })) return Promise.resolve();
    var errEl = form ? form.querySelector('[data-add-error]') : null; if (errEl) errEl.hidden = true;
    var sheet = form ? form.closest('dialog') : null;
    if (!document.querySelector('#cart-drawer.is-open')) opener = document.activeElement;
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return cartPost('/cart/add.js', { items: items, sections: cartSections(), sections_url: location.pathname })
      .then(function (res) {
        if (!res.ok || !res.data) throw res;
        if (sheet && sheet.open) sheet.close();
        if (res.data.sections && res.data.sections['cart-drawer']) renderCart(res.data.sections);
        open('cart');
        if (!(res.data.sections && res.data.sections['cart-drawer'])) refreshCart();
      })
      .catch(function (res) {
        var msg = res && res.data && (res.data.description || res.data.message);
        if (typeof msg !== 'string' || !msg) msg = ADD_FAILED;
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
        else { var bagErr = document.querySelector('#cart-drawer [data-line-msg]'); if (bagErr) { bagErr.textContent = msg; bagErr.hidden = false; } }
      })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  }

  /* Add to bag: the product page form (and its sticky bar, via form=), the picker sheet,
     and Complete the look. Nothing is added until every option has been chosen. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (form) {
      e.preventDefault();
      var po = initOptions(form.querySelector('[data-po]'));
      var v = po ? po.validate() : null;
      if (v) addToBag([{ id: v.id, quantity: 1 }], form);
      return;
    }
    var look = e.target.closest('[data-look-form]');
    if (look) {
      e.preventDefault();
      var items = [], ok = true;
      look.querySelectorAll('[data-look-item]').forEach(function (it) {
        var inc = it.querySelector('[data-look-include]'); if (inc && !inc.checked) return;
        var p = initOptions(it.querySelector('[data-po]')); var lv = p ? p.validate() : null;
        if (lv) items.push({ id: lv.id, quantity: 1 }); else ok = false;
      });
      if (ok && items.length) addToBag(items, look);
      return;
    }
    /* Check out: a pressed, loading button, and no double submits */
    var co = e.target.closest('[data-checkout-form]');
    if (co) {
      if (co.__going) { e.preventDefault(); return; }
      co.__going = true;
      var cb = co.querySelector('[data-checkout]'); if (cb) { cb.classList.add('is-loading'); cb.setAttribute('aria-busy', 'true'); }
    }
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-checkout-form]').forEach(function (f) { f.__going = false; var cb = f.querySelector('[data-checkout]'); if (cb) { cb.classList.remove('is-loading'); cb.removeAttribute('aria-busy'); } });
  });

  /* Quantity and remove, in the side cart and on the cart page. Only the line being changed
     looks busy, and taps are ignored while a change is on its way. */
  var cartBusy = false;
  document.addEventListener('click', function (e) {
    var ctl = e.target.closest('[data-line][data-change]'); if (!ctl) return;
    e.preventDefault();
    if (cartBusy) return;
    cartBusy = true;
    var line = ctl.closest('.sc-line'), msg = line && line.querySelector('[data-line-msg]');
    if (line) line.classList.add('is-busy');
    /* the number changes on the tap; the response then confirms it (or puts it back) */
    var shown = line && line.querySelector('.sc-qty__val'), want = parseInt(ctl.getAttribute('data-change'), 10), was = shown ? shown.textContent : '';
    if (shown && want > 0) shown.textContent = want;
    if (msg) msg.hidden = true;
    cartPost('/cart/change.js', { line: parseInt(ctl.getAttribute('data-line'), 10), quantity: parseInt(ctl.getAttribute('data-change'), 10), sections: cartSections(), sections_url: location.pathname })
      .then(function (res) {
        if (res.ok && res.data && res.data.sections) { renderCart(res.data.sections); return; }
        var text = res.data && (res.data.description || res.data.message);
        if (line) line.classList.remove('is-busy');
        if (shown) shown.textContent = was;
        if (msg && typeof text === 'string' && text) { msg.textContent = text; msg.hidden = false; } else return refreshCart();
      })
      .catch(function () { if (line) line.classList.remove('is-busy'); if (shown) shown.textContent = was; return refreshCart(); })
      .then(function () { cartBusy = false; });
  });

  /* Complete the outfit: a piece that comes one way only is added with one tap … */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-addon-add]'); if (!b) return;
    e.preventDefault();
    addToBag([{ id: +b.getAttribute('data-addon-add'), quantity: 1 }], null, b);
  });
  /* … anything with a colour or size to choose opens the picker in a sheet (sections/quick-add.liquid) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    var sheet = document.getElementById('quick-add-sheet'); if (!sheet || !sheet.showModal) return;
    e.preventDefault();
    var url = b.getAttribute('data-quick-add');
    var body = sheet.querySelector('[data-sheet-body]');
    body.innerHTML = '<div class="sheet__loading" role="status"><span class="visually-hidden">Loading</span></div>';
    if (!sheet.open) sheet.showModal();
    fetch(url + '?section_id=quick-add')
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var qa = tmp.querySelector('[data-qa]'); if (!qa) throw 0;
        body.innerHTML = ''; body.appendChild(qa);
        initOptions(qa.querySelector('[data-po]'));
      })
      .catch(function () { location.href = url; });
  });

  /* A page served from a prefetch or the back/forward cache may carry an old bag */
  function keepCartFresh() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.deliveryType === 'navigational-prefetch') refreshCart();
    } catch (e) {}
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  }

  /* ---------------------------------------------------------------------------
     Lower product page: sections fetched when they are needed
  --------------------------------------------------------------------------- */
  /* Complete the look: the piece on the page plus up to two that go with it */
  function completeLook() {
    var el = document.querySelector('[data-complete-look]'); if (!el) return;
    whenNear(el, '900px 0px', function () {
      var url = el.getAttribute('data-url'), chosen = document.querySelector('#product-form [data-po-id]');
      if (chosen && chosen.value) url += '&variant=' + chosen.value;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var sec = tmp.querySelector('[data-look]'); if (!sec) return;
          el.replaceWith(sec);
          sec.querySelectorAll('[data-po]').forEach(initOptions);
          var main = document.querySelector('#product-form [data-po]');
          if (main && main.__po) syncLookCurrent(main.__po.state.variant);
          lookTotal(sec);
        })
        .catch(function () {});
    });
  }

  function whenIdle(fn) {
    var go = function () { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 1200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }
  /* Styled with: complementary products, only for products without their own styled-with list */
  function styledWith() {
    var el = document.querySelector('[data-styled-with][data-url]'); if (!el) return;
    whenIdle(function () {
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var chips = tmp.querySelector('[data-styled-chips]'); if (!chips || !chips.children.length) return;
          var row = el.querySelector('[data-styled-row]');
          while (chips.firstElementChild) row.appendChild(chips.firstElementChild);
          el.hidden = false;
        })
        .catch(function () {});
    });
  }
  /* You may also like: Shopify's recommendations replace the collection fallback when there are enough */
  function productRecs() {
    var track = document.querySelector('[data-recs][data-url]'); if (!track) return;
    whenNear(track, '900px 0px', function () {
      fetch(track.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var cards = slice(tmp.querySelectorAll('[data-recs-cards] .product-card')); if (cards.length < 4) return;
          track.innerHTML = ''; cards.forEach(function (c) { track.appendChild(c); });
          track.scrollLeft = 0;
        })
        .catch(function () {});
    });
  }

  /* Recently viewed: product ids live in this browser only */
  function recentlyViewed() {
    var el = document.querySelector('[data-recently-viewed]'); if (!el) return;
    var KEY = 'sc:recent', ids = [];
    try { ids = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { ids = []; }
    if (!Array.isArray(ids)) ids = [];
    var cur = el.getAttribute('data-product-id');
    var others = ids.filter(function (id) { return id !== cur && /^\d+$/.test(id); }).slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify([cur].concat(others).slice(0, 12))); } catch (e) {}
    if (!others.length) return;
    whenNear(el, '900px 0px', function () {
      var q = others.map(function (id) { return 'id:' + id; }).join(' OR ');
      fetch(el.getAttribute('data-url') + '?section_id=recently-viewed&type=product&q=' + encodeURIComponent(q))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var sec = tmp.querySelector('section'); if (!sec) return;
          el.replaceWith(sec);
        })
        .catch(function () {});
    });
  }


  /* ---------------------------------------------------------------------------
     Desktop: shop page, product cards, search panel, menu, page contents list.
     Everything below is either gated on a desktop media query or acts on elements
     that phones never show, so phones behave exactly as before.
  --------------------------------------------------------------------------- */
  var DESKTOP = window.matchMedia ? matchMedia('(min-width: 990px)') : { matches: false };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Shop page (a collection or search results): on desktop, filters, sort and "Load more" happen
     in place through the Section Rendering API, the URL keeps up, and coming back from a product
     page lands where the shopper left off. Phones keep their drawer, select and numbered pages. */
  function shop() {
    var root = document.querySelector('[data-shop]'); if (!root) return;
    var sid = root.getAttribute('data-section'), busy = false, KEY = 'sc:shop:';
    var part = function (scope) {
      return { results: scope.querySelector('[data-shop-results]'), facets: slice(scope.querySelectorAll('[data-shop-facets]')), counts: slice(scope.querySelectorAll('[data-shop-count]')), sort: scope.querySelector('[data-shop-sort]') };
    };
    function go(url, append) {
      if (busy) return; busy = true;
      var u = new URL(url, location.href), f = new URL(u.href); f.searchParams.set('section_id', sid);
      root.classList.add('is-loading');
      fetch(f.href)
        .then(function (r) { if (!r.ok) throw r; return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-shop]'); if (!fresh) throw 0;
          var a = part(root), b = part(fresh);
          if (!a.results || !b.results) throw 0;
          if (append) {
            var grid = a.results.querySelector('[data-shop-grid]'), more = a.results.querySelector('[data-shop-more]'), next = b.results.querySelector('[data-shop-more]');
            var first = null;
            slice(b.results.querySelectorAll('[data-shop-grid] > *')).forEach(function (c) { if (!first) first = c; grid.appendChild(c); });
            if (next) { var prev = next.querySelector('.shop-more__prev'); if (prev) prev.remove(); }
            if (more && next) more.replaceWith(next); else if (more) more.remove();
            /* keyboard users carry on from the first new piece */
            var link = first && first.querySelector('a'); if (link && document.activeElement === document.body) link.focus({ preventScroll: true });
          } else {
            /* keep the open filter panel open and the focused control focused across the swap */
            var open = slice(root.querySelectorAll('[data-facet][open]')).map(function (d) { return d.getAttribute('data-facet'); });
            var el = document.activeElement, focus = el && root.contains(el) && el.name ? { name: el.name, value: el.type === 'checkbox' ? el.value : null } : null;
            a.results.innerHTML = b.results.innerHTML;
            a.facets.forEach(function (x, i) { if (b.facets[i]) x.innerHTML = b.facets[i].innerHTML; });
            a.counts.forEach(function (x, i) { if (b.counts[i]) x.textContent = b.counts[i].textContent; });
            if (a.sort && b.sort) a.sort.innerHTML = b.sort.innerHTML;
            slice(root.querySelectorAll('.facets--bar [data-facet]')).forEach(function (d) { d.open = open.indexOf(d.getAttribute('data-facet')) > -1; });
            if (focus) {
              var again = slice(root.querySelectorAll('[data-facets] [name="' + focus.name.replace(/"/g, '\\"') + '"]')).filter(function (x) { return focus.value == null || x.value === focus.value; })[0];
              if (again) again.focus({ preventScroll: true });
            }
          }
          history.replaceState(history.state, '', u.pathname + u.search);
          lazyImages(root);
        })
        .catch(function () { location.href = url; })
        .then(function () { busy = false; root.classList.remove('is-loading'); });
    }
    function applyFacets(form) {
      var params = new URLSearchParams(new FormData(form)), drop = [];
      params.forEach(function (v, k) { if (v === '') drop.push(k); });
      drop.forEach(function (k) { params.delete(k); });
      var q = params.toString(), action = form.getAttribute('action');
      go(action + (q ? (action.indexOf('?') > -1 ? '&' : '?') + q : ''));
    }
    root.addEventListener('change', function (e) { var form = e.target.closest('[data-facets]'); if (form) applyFacets(form); });
    root.addEventListener('submit', function (e) { var form = e.target.closest('[data-facets]'); if (form) { e.preventDefault(); applyFacets(form); } });
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-shop-link]');
      if (link) { e.preventDefault(); go(link.getAttribute('href')); return; }
      var sort = e.target.closest('[data-sort]');
      if (sort) {
        e.preventDefault();
        var u = new URL(location.href); u.searchParams.set('sort_by', sort.getAttribute('data-sort')); u.searchParams.delete('page');
        var dd = sort.closest('details'); if (dd) dd.open = false;
        go(u.pathname + u.search); return;
      }
      var more = e.target.closest('[data-shop-more-link]');
      if (more) { e.preventDefault(); go(more.getAttribute('href'), true); }
    });
    /* One dropdown open at a time; a click elsewhere or Esc closes it */
    var drops = function () { return slice(root.querySelectorAll('.facets--bar [data-facet], [data-sortdd]')); };
    root.addEventListener('toggle', function (e) {
      var d = e.target; if (!d.open || !d.matches || !d.matches('.facets--bar [data-facet], [data-sortdd]')) return;
      drops().forEach(function (x) { if (x !== d) x.open = false; });
    }, true);
    document.addEventListener('click', function (e) { drops().forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      drops().forEach(function (d) { if (d.open) { d.open = false; var sm = d.querySelector('summary'); if (sm && d.contains(document.activeElement)) sm.focus(); } });
    });

    /* Back from a product page (desktop): the same pieces loaded, at the same scroll position */
    var key = function () { return KEY + location.pathname + location.search; };
    window.addEventListener('pagehide', function () {
      var r = root.querySelector('[data-shop-results]'); if (!r || !DESKTOP.matches) return;
      try { sessionStorage.setItem(key(), JSON.stringify({ html: r.innerHTML, y: window.scrollY, t: Date.now() })); } catch (e) {}
    });
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (DESKTOP.matches && nav && nav.type === 'back_forward') {
        var st = JSON.parse(sessionStorage.getItem(key()) || 'null'), res = root.querySelector('[data-shop-results]');
        if (st && res && Date.now() - st.t < 1800000) {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          res.innerHTML = st.html; lazyImages(res);
          requestAnimationFrame(function () { window.scrollTo(0, st.y); });
        }
      }
    } catch (e) {}
  }

  /* Product cards with a mouse: hovering shows the sizes, and clicking one adds that size straight
     to the bag; a colour dot picks the colour that is added (and shows its photo when the colour
     has one). Touch screens keep the plain card. */
  function cards() {
    var mq = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    if (!mq || !mq.matches) return;
    function colorIndex(p) {
      for (var i = 0; i < p.options.length; i++) { var n = String(p.options[i].name || p.options[i]).toLowerCase(); if (n.indexOf('colo') > -1) return i; }
      return -1;
    }
    function markDots(card) {
      slice(card.querySelectorAll('.product-card__dot[data-color]')).forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-color') === card.__color); });
    }
    function build(card) {
      var p = card.__p, media = card.querySelector('.product-card__media'); if (!p || !media) return;
      var ci = colorIndex(p);
      if (card.__color == null && ci > -1) {
        var firstAvail = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        card.__color = firstAvail.options[ci]; markDots(card);
      }
      var list = p.variants.filter(function (v) { return ci < 0 || v.options[ci] === card.__color; });
      var panel = media.querySelector('.pc-quick');
      if (!panel) { panel = document.createElement('div'); panel.className = 'pc-quick'; media.appendChild(panel); }
      var label = '<span class="pc-quick__label">Quick add' + (ci > -1 ? ' <b>' + esc(card.__color) + '</b>' : '') + '</span>';
      if (list.length > 1) {
        panel.innerHTML = label + '<div class="pc-quick__sizes">' + list.map(function (v) {
          var size = v.options.filter(function (x, i) { return i !== ci; }).join(' / ').split('(')[0].trim();
          return '<button type="button" class="pc-quick__size" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-label="Add size ' + esc(size) + ' to bag">' + esc(size) + '</button>';
        }).join('') + '</div>';
      } else {
        panel.innerHTML = (ci > -1 ? label : '') + '<button type="button" class="pc-quick__add" data-vid="' + (list[0] ? list[0].id : '') + '"' + (list[0] && list[0].available ? '' : ' disabled') + '>Add to bag</button>';
      }
    }
    function prime(card) {
      if (card.__primed) return;
      var url = card.getAttribute('data-card-url'); if (!url) return;
      card.__primed = true;
      fetch(url + '.js')
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (p) { card.__p = p; build(card); })
        .catch(function () { card.__primed = false; });
    }
    function pick(dot) {
      var card = dot.closest('.product-card'); if (!card || !card.__p || card.__color === dot.getAttribute('data-color')) return;
      card.__color = dot.getAttribute('data-color'); markDots(card);
      var p = card.__p, ci = colorIndex(p), img = card.querySelector('.product-card__img');
      var withPhoto = p.variants.filter(function (v) { return v.options[ci] === card.__color && v.featured_image && v.featured_image.src; })[0];
      if (withPhoto && img) {
        var src = withPhoto.featured_image.src;
        img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
        img.srcset = [300, 450, 600, 900].map(function (w) { return uncropped(src, w) + ' ' + w + 'w'; }).join(', ');
        img.src = uncropped(src, 600); card.classList.add('is-swapped');
      }
      build(card);
    }
    document.addEventListener('mouseover', function (e) { var card = e.target.closest && e.target.closest('.product-card[data-card-url]'); if (card) prime(card); });
    document.addEventListener('focusin', function (e) { var card = e.target.closest && e.target.closest('.product-card[data-card-url]'); if (card) prime(card); });
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.product-card__dot[data-color]');
      if (dot) { e.preventDefault(); pick(dot); return; }
      var b = e.target.closest('.pc-quick [data-vid]'); if (!b) return;
      e.preventDefault();
      var panel = b.closest('.pc-quick'); if (panel.classList.contains('is-busy')) return;
      panel.classList.add('is-busy'); panel.classList.remove('has-msg'); b.classList.add('is-loading');
      opener = b;
      cartPost('/cart/add.js', { items: [{ id: +b.getAttribute('data-vid'), quantity: 1 }], sections: cartSections(), sections_url: location.pathname })
        .then(function (res) {
          if (!res.ok || !res.data) throw res;
          if (res.data.sections && res.data.sections['cart-drawer']) renderCart(res.data.sections);
          open('cart');
          if (!(res.data.sections && res.data.sections['cart-drawer'])) refreshCart();
        })
        .catch(function (res) {
          var msg = res && res.data && (res.data.description || res.data.message);
          panel.setAttribute('data-msg', typeof msg === 'string' && msg ? msg : ADD_FAILED);
          panel.classList.add('has-msg'); setTimeout(function () { panel.classList.remove('has-msg'); }, 4500);
        })
        .then(function () { panel.classList.remove('is-busy'); b.classList.remove('is-loading'); });
    });
  }

  /* Search panel (desktop): the header's search icon opens a panel under the header instead of
     going to the search page. Before typing: recent searches (this browser only) and the
     categories. While typing: suggested searches, matching collections and products. */
  function searchPanel() {
    var panel = document.getElementById('search-panel'); if (!panel || !panel.showModal) return;
    var input = panel.querySelector('[data-search-input]'), live = panel.querySelector('[data-search-live]'), idle = panel.querySelector('[data-search-idle]');
    if (!input || !live || !idle) return;
    var timer, controller, last = '', RECENT = 'sc:searches';
    var ICON = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg>';
    function cents(p) { var n = parseFloat(String(p == null ? '' : p).replace(/,/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
    function recent() { try { var a = JSON.parse(localStorage.getItem(RECENT) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }).slice(0, 5) : []; } catch (e) { return []; } }
    function remember(q) {
      q = String(q || '').trim().slice(0, 60); if (q.length < 2) return;
      try { var a = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); localStorage.setItem(RECENT, JSON.stringify(a.slice(0, 5))); } catch (e) {}
    }
    function drawRecent() {
      var box = panel.querySelector('[data-search-recent]'); if (!box) return;
      var a = recent(); box.hidden = !a.length;
      box.innerHTML = a.length ? '<p class="sp__label">Recent searches <button type="button" class="sp__textbtn" data-search-forget>Clear</button></p><div class="sp__links">' +
        a.map(function (q) { return '<button type="button" class="sp__link" data-search-term="' + esc(q) + '">' + esc(q) + '</button>'; }).join('') + '</div>' : '';
    }
    function showIdle() { live.hidden = true; live.innerHTML = ''; idle.hidden = false; }
    function draw(q, res) {
      var products = (res.products || []).slice(0, 4), queries = res.queries || [], colls = res.collections || [];
      live.classList.remove('is-loading');
      if (!products.length && !queries.length && !colls.length) {
        live.innerHTML = '<p class="sp__none">No results for <strong>&ldquo;' + esc(q) + '&rdquo;</strong>. Check the spelling, or try a shorter word.</p>';
        live.hidden = false; idle.hidden = false; return;
      }
      var side = '';
      if (queries.length) side += '<div class="sp__group"><p class="sp__label">Suggestions</p><div class="sp__terms">' + queries.slice(0, 4).map(function (s) {
        return '<a class="sp__term" href="/search?type=product&q=' + encodeURIComponent(s.text) + '" data-search-save="' + esc(s.text) + '">' + ICON + '<span>' + esc(s.text) + '</span></a>';
      }).join('') + '</div></div>';
      if (colls.length) side += '<div class="sp__group"><p class="sp__label">Collections</p><div class="sp__terms">' + colls.slice(0, 3).map(function (c) {
        return '<a class="sp__term" href="' + esc(String(c.url).split('?')[0]) + '" data-search-save="' + esc(q) + '"><span>' + esc(c.title) + '</span></a>';
      }).join('') + '</div></div>';
      var list = products.map(function (p) {
        var bits = String(p.title || '').split('|'), name = bits[0].trim(), sub = bits.slice(1).join('|').trim();
        if (sub) sub = sub.charAt(0).toUpperCase() + sub.slice(1).toLowerCase();   /* sentence case, as on the cards */
        var lo = cents(p.price_min != null ? p.price_min : p.price), was = cents(p.compare_at_price_max);
        var img = p.image ? '<img src="' + esc(uncropped(p.image, 360)) + '" alt="" width="360" height="450" loading="lazy" decoding="async">' : '';
        return '<a class="sp-item" href="' + esc(String(p.url).split('?')[0]) + '" data-search-save="' + esc(q) + '"><span class="sp-item__media">' + img + '</span>' +
          '<span class="sp-item__name">' + esc(name) + '</span>' + (sub ? '<span class="sp-item__sub">' + esc(sub) + '</span>' : '') +
          '<span class="sp-item__price">' + (lo != null ? esc(money(lo)) : '') + (was != null && lo != null && was > lo * 1.01 ? ' <s>' + esc(money(was)) + '</s>' : '') + (p.available === false ? ' <em>Sold out</em>' : '') + '</span></a>';
      }).join('');
      var main = products.length ? '<div class="sp__main"><p class="sp__label">Products</p><div class="sp__grid">' + list + '</div>' +
        '<a class="btn btn--secondary sp__all" href="/search?type=product&q=' + encodeURIComponent(q) + '" data-search-save="' + esc(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a></div>' : '';
      live.innerHTML = '<div class="sp__results' + (side && main ? '' : ' sp__results--solo') + '">' + (side ? '<div class="sp__side">' + side + '</div>' : '') + main + '</div>';
      live.hidden = false; idle.hidden = true;
    }
    function run(q) {
      if (window.AbortController) { if (controller) controller.abort(); controller = new AbortController(); }
      live.classList.add('is-loading');
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last', controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === q) draw(q, ((data || {}).resources || {}).results || {}); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; if (input.value.trim() === q) draw(q, {}); });
    }
    function typed() {
      var q = input.value.trim();
      if (q === last) return; last = q;
      clearTimeout(timer);
      if (q.length < 2) { if (controller) controller.abort(); showIdle(); return; }
      timer = setTimeout(function () { run(q); }, 160);
    }
    input.addEventListener('input', typed);
    if (input.form) input.form.addEventListener('submit', function (e) { var q = input.value.trim(); if (!q) { e.preventDefault(); return; } remember(q); });
    panel.addEventListener('click', function (e) {
      if (e.target === panel) { panel.close(); return; }   /* the backdrop */
      var term = e.target.closest('[data-search-term]');
      if (term) { input.value = term.getAttribute('data-search-term'); typed(); input.focus(); return; }
      if (e.target.closest('[data-search-forget]')) { try { localStorage.removeItem(RECENT); } catch (err) {} drawRecent(); return; }
      var save = e.target.closest('[data-search-save]'); if (save) remember(save.getAttribute('data-search-save'));
    });
    /* Esc closes the panel at once (a search field would otherwise use the first press to clear itself);
       arrow keys walk through the results from the field */
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); panel.close(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = slice(live.querySelectorAll('a')).filter(function (a) { return a.offsetParent !== null; }); if (!links.length) return;
      var at = links.indexOf(document.activeElement), next = e.key === 'ArrowDown' ? at + 1 : at - 1;
      e.preventDefault();
      if (next < 0) input.focus(); else if (next < links.length) links[next].focus();
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-search-open]'); if (!b || !DESKTOP.matches) return;
      e.preventDefault();
      if (panel.open) return;
      drawRecent(); panel.showModal(); input.focus(); input.select();
    });
  }

  /* Desktop menu: the dropdowns open on hover and on keyboard focus through CSS. This adds Esc to
     close, a first tap to open on touch screens wide enough for the desktop header, and keeps
     aria-expanded true to what is on screen. */
  function megaMenu() {
    var items = slice(document.querySelectorAll('.header__item')).filter(function (it) { return it.querySelector('.mega'); });
    if (!items.length) return;
    var canHover = window.matchMedia && matchMedia('(hover: hover)').matches;
    function sync() {
      items.forEach(function (it) {
        var link = it.querySelector('.nav-link'); if (!link) return;
        var on = !it.classList.contains('is-shut') && (it.classList.contains('is-open') || it.matches(':hover') || it.contains(document.activeElement));
        link.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    items.forEach(function (it) {
      var link = it.querySelector('.nav-link');
      it.addEventListener('mouseenter', sync); it.addEventListener('focusin', sync);
      it.addEventListener('mouseleave', function () { it.classList.remove('is-shut'); sync(); });
      it.addEventListener('focusout', function () { setTimeout(function () { if (!it.contains(document.activeElement)) it.classList.remove('is-shut'); sync(); }, 0); });
      it.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        it.classList.add('is-shut'); it.classList.remove('is-open'); if (link) link.focus(); sync();
      });
      if (!canHover && link) link.addEventListener('click', function (e) {
        if (!DESKTOP.matches || it.classList.contains('is-open')) return;
        e.preventDefault();
        items.forEach(function (x) { x.classList.remove('is-open'); });
        it.classList.add('is-open'); sync();
      });
    });
    if (!canHover) document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.header__item')) return;
      items.forEach(function (x) { x.classList.remove('is-open'); }); sync();
    });
  }

  /* "On this page" (policy pages) and "Topics" (Help): a list built from the page's headings,
     shown beside the text on desktop, with the section on screen marked. */
  function contents() {
    var nav = document.querySelector('[data-toc]'), body = document.querySelector('[data-toc-body]');
    if (!nav || !body || !DESKTOP.matches) return;
    var heads = slice(body.querySelectorAll(nav.getAttribute('data-toc') || 'h2')); if (heads.length < 3) { nav.hidden = true; return; }
    var used = {}, links = [];
    heads.forEach(function (h) {
      var target = h.closest('.faq-group') || h;
      if (!target.id) {
        var id = h.textContent.trim().toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
        while (used[id] || document.getElementById(id)) id += '-2';
        used[id] = true; target.id = id;
      }
      var a = document.createElement('a'); a.href = '#' + target.id; a.textContent = h.textContent.trim(); a.className = 'toc__link';
      nav.appendChild(a); links.push({ a: a, el: target });
    });
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { seen[en.target.id] = en.isIntersecting; });
      var cur = null;
      links.forEach(function (l) { if (!cur && seen[l.el.id]) cur = l; });
      if (!cur) return;
      links.forEach(function (l) { if (l === cur) l.a.setAttribute('aria-current', 'true'); else l.a.removeAttribute('aria-current'); });
    }, { rootMargin: '-90px 0px -55% 0px' });
    links.forEach(function (l) { io.observe(l.el); });
  }

  function later(fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 }); else setTimeout(fn, 60); }

  function init() {
    lazyImages(); observeReveals(); headerScroll(); gallery();
    document.querySelectorAll('[data-po]').forEach(initOptions);
    stickyAtc(); keepCartFresh(); completeLook(); styledWith(); productRecs(); recentlyViewed();
    shop(); contents();
    later(function () { cards(); searchPanel(); megaMenu(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
